import React from "react";
import UpdatePassword from "../../athlete/account/UpdatePassword";

export default function AdminUpdatePassword() {
  return <UpdatePassword title="Update Password" />;
}
